export const formatAiDecision = (decision: string | null) => {
  switch (decision) {
    case "approved":
      return "Godkendt";
    case "rejected":
      return "Afvist";
    default:
      return decision ?? "-";
  }
};
